import React, { ReactElement } from 'react';
import { FastField, FastFieldProps } from 'formik';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { TFunction } from 'i18next';

export interface ProfileFieldProps {
  name: string;
  t: TFunction;
  label: string;
  defaultValue?: number | string;
  disabled?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputField: {
      marginBottom: theme.spacing(3)
    },
    inputLabel: {
      fontWeight: 600
    },
    danger: {
      color: theme.palette.error.main
    }
  })
);

const ProfileField = ({ name, t, label, disabled = false }: ProfileFieldProps): ReactElement => {
  const classes = useStyles();
  return (
    <FastField name={name}>
      {({ field, meta }: FastFieldProps): ReactElement[] => [
        <Typography
          key={`${field.name}_label`}
          variant="body1"
          className={clsx(
            classes.inputLabel,
            Boolean(meta.touched && meta.error) && classes.danger
          )}
        >
          {t(label)}
        </Typography>,
        <TextField
          {...field}
          key={`${field.name}_input`}
          fullWidth
          placeholder={t(label)}
          autoComplete="off"
          variant="outlined"
          size="small"
          error={Boolean(meta.touched && meta.error)}
          helperText={meta.touched && meta.error}
          className={classes.inputField}
          inputProps={{
            'aria-label': t(label)
          }}
          {...(disabled && { disabled })}
        />
      ]}
    </FastField>
  );
};

export default ProfileField;
